import { PackStatusDto, PackStatusDtoImpl } from './packstatusdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { BaseContext } from '../../../utils/basecontext';

export class PackStatusBuilder {
    constructor(private packStatus: any,  context: BaseContext) {
        if(packStatus.packStatusDetails === undefined)
        {
            throw new NoDataException("Pack Status data doesnt exists");
        }
    }

    buildAll(): PackStatusDto {
        return this.parsePackStatusDetailsResponse();
    }

    private parsePackStatusDetailsResponse(): PackStatusDto
    {
        let packStatusItem = this.packStatus.packStatusDetails;
        let packStatusDto = new PackStatusDtoImpl();

        packStatusDto.setActiveRRBTStatus(packStatusItem.activeRRBTStatus);
        packStatusDto.setActiveCRBTStatus(packStatusItem.activeCRBTStatus);
        packStatusDto.setRrbtServiceExpiry(packStatusItem.rrbtServiceExpiry);
        packStatusDto.setCrbtServiceExpiry(packStatusItem.crbtServiceExpiry);
        packStatusDto.setLanguageId(packStatusItem.languageId);
        packStatusDto.setPackName(packStatusItem.packName);
      
        return packStatusDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/packstatus/packstatusbuilder.ts